<template>
    <!--<div class="" v-for="(board, index) in boardData" :key="`news${board.wr_id}`" style="display: inline-block">
        <div style="width: 350px; height: 220px;" :style="`background-image:url(${returnImage(board)})`"></div>
        <div>{{board.wr_subject}}</div> &lt;!&ndash;두줄이상 되면 말줄임이 되어야 합니다. &ndash;&gt;
    </div>-->
    <!--<div>
        <div class="donatenews_border"></div>
        <div class="donatenews_body">
            <div class="donatenews_contents">
                <div class="contents_image"></div>
                <div class="contests_text"> 아이들을 지키는 백신프로젝트:백 원의 신나는 나눔 그리고</div>
            </div>
            <div class="donatenews_contents">
                <div class="contents_image"></div>
                <div class="contests_text"> 아이들을 지키는 백신프로젝트:백 원의 신나는 나눔 그리고</div>
            </div>
            <div class="donatenews_contents">
                <div class="contents_image"></div>
                <div class="contests_text"> 아이들을 지키는 백신프로젝트:백 원의 신나는 나눔 그리고</div>
            </div>
        </div>
    </div>-->
    <div class=" content homenews">
        <div class="homenews_body">
            <div class="homenews_contents1" v-for="(board, index) in boardData" :key="`news${board.wr_id}`"
                 @click="goDetail(board.wr_id)">
                <div class="contents_image" :style="`background-image:url(${returnImage(board)})`" ></div>
                <div class="contests_text">{{board.wr_subject}}</div> <!--제목이 두줄이상 되면 말줄임이 되어야 합니다. -->
            </div>
        </div>
    </div>

</template>

<script>
    import imageOption from "@/mixins/imageOption";
    import util from "@/mixins/util";

    export default {
        name: "BoardListHomeDonateLayout",
        mixins: [imageOption],
        components: {},
        props: {
            boardData: {
                type: Array,
                default: () => {
                    return []
                }
            },
        },
        data() {
            return {}
        },
        beforeRouterEnter() {
        },
        created() {
        },
        mounted() {

        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {

            returnImage(data) {
                if (this.hasFile(data)) {
                    return `${data.NoticeFile.File[0].org_url}?${this.setImageOptions(350, 220, 'jpg')}`
                }
                else { return ''}
            },
            hasFile(data) {
                return !util.isEmpty(data.NoticeFile) && data.NoticeFile.hasOwnProperty('File') && !util.isEmpty(data.NoticeFile.File)
            },
            goDetail(idx){
                this.$router.push(`/donate/${idx}`)
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>